export default __webpack_public_path__ + "static/logo-sm-8c54332c24246f1d7b6ade86eceb22a4.png";